import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/feature/Header";

const STORAGE_KEY = "rt_checkout_url";

export default function CheckoutPage() {
  const navigate = useNavigate();
  const [checkoutUrl, setCheckoutUrl] = useState<string | null>(null);

  useEffect(() => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) {
      navigate("/", { replace: true });
      return;
    }
    setCheckoutUrl(stored);
  }, [navigate]);

  if (!checkoutUrl) return null;

  return (
    <div className="storefront flex h-screen flex-col bg-background-50">
      <Header />
      {/* O checkout da Nuvemshop renderiza sua própria barra de logo no topo
          (60px no desktop, 64px no mobile, medido ao vivo). Como já temos o
          header real do site logo acima, cortamos essa faixa duplicada
          deslocando o iframe pra cima dentro de um contêiner com overflow
          escondido, sem depender de nenhuma configuração da loja. */}
      <div className="relative flex-1 overflow-hidden bg-background-50">
        <iframe
          src={checkoutUrl}
          title="Finalizar compra"
          className="absolute inset-x-0 -top-16 h-[calc(100%+4rem)] w-full border-0 md:-top-[60px] md:h-[calc(100%+60px)]"
        />
      </div>
    </div>
  );
}
